import { PostalAddress } from '../../../common/model/postal-address';
import { LocalDate } from '../../../core/model/local-date';
import { ModelBase } from '../../../core/model/model-base';
import { Money } from '../../../core/model/money';
import { InvoiceDeliveryMethod } from '../../../invoice/model/const/enum';
import { RentalObjectCategory } from '../const/enums';
import { TransferType } from '../const/transfer-type';
import { TransferBuyer } from './transfer-buyer';
import { TransferSeller } from './transfer-seller';

export class BrfTransferForm extends ModelBase {
  constructor(data?: any) {
    super();
    if (data) {
      this.id = data.id;
      this.oldAgreementId = data.oldAgreementId;
      this.oldLeaseAgreementNumber = data.oldLeaseAgreementNumber;
      this.rentalId = data.rentalId;
      this.objectCategory = data.objectCategory;
      this.sellers = Array.isArray(data.sellers) ? data.sellers.map(s => new TransferSeller(s)) : [];
      this.buyers = Array.isArray(data.buyers) ? data.buyers.map(b => new TransferBuyer(b)) : [];
      this.transferDate = LocalDate.fromDate(data.transferDate);
      this.leaseAgreementNumber = data.leaseAgreementNumber;
      this.amount = data.amount;
      this.transferType = data.transferType;
      this.additionalPayment_639 = data.additionalPayment_639;
      this.innerFund_635 = data.innerFund_635;
    }
  }
  oldAgreementId: string;
  oldLeaseAgreementNumber: string;
  rentalId: string;
  objectCategory: RentalObjectCategory;
  sellers: TransferSeller[];
  buyers: TransferBuyer[];
  transferDate: LocalDate;
  leaseAgreementNumber: string;
  amount: Money;
  transferType: TransferType;
  currencyCode: string;
  additionalPayment_639: Money;
  innerFund_635: Money;

  toString() {    
    const id = this.rentalId ? this.rentalId : '';
    const date = this.transferDate ? (this.transferDate.hasValue ? new Date(this.transferDate.year, this.transferDate.month - 1, this.transferDate.day).toLocaleDateString() : '') : '';
    return `${id} ${date}`.trim();
  }
}
